import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '@/pages/Login';
import RegistroPage from '@/pages/RegistroPage';
import AppLayout from '@/shared/AppLayout';
import SolicitudesPage from '@/pages/SolicitudesPage';
import CotizarPage from '@/pages/CotizarPage';
import CotizacionesPage from '@/pages/CotizacionesPage';
import CotizacionDetailPage from '@/pages/CotizacionDetailPage';
import DepositosPage from '@/pages/DepositosPage';
import ServiciosPage from '@/pages/ServiciosPage';
import EmpresaPage from '@/pages/empresa/EmpresaPage';
import { DEFAULT_ROUTE } from '@/shared/nav-items';

/**
 * The route composition. One literal list for now — this moves to a feature-first
 * `src/features/<name>/routes.tsx` + spread, mirroring nexvia-backoffice's src/app/router.tsx,
 * the day a page grows past what fits one file and its own route sub-tree. Not before: inventing
 * that structure ahead of need is the premature layer AGENTS.md warns against.
 *
 * All five sidebar routes below render their real Milestone 2/3/4/5 pages, plus
 * `solicitudes/:id/cotizar` (NEX-1165 design pass: the quote form as a page) and `cotizaciones/:id` (one
 * quote, in full). `depositos` → `DepositosPage`
 * has done so since Milestone 3 landed (2026-10-13) — this comment used to say otherwise
 * ("still <PlaceholderPage/>, not built yet"), which was already false by the time anyone read it.
 * See docs/TECHNICAL-AUDIT.md F-015.
 */
export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* NEX-1164 — the registration form: signed in, but outside the shell (no account yet). */}
      <Route path="/registro" element={<RegistroPage />} />

      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to={DEFAULT_ROUTE} replace />} />
        <Route path="solicitudes" element={<SolicitudesPage />} />
        {/* NEX-1165 design pass (decision D-2.1) — Cotizar is a page, no longer a dialog over the list. */}
        <Route path="solicitudes/:id/cotizar" element={<CotizarPage />} />
        <Route path="cotizaciones" element={<CotizacionesPage />} />
        {/* Quote detail page (2026-10-28) — one page per quote; the list carries only the summary. */}
        <Route path="cotizaciones/:id" element={<CotizacionDetailPage />} />
        <Route path="depositos" element={<DepositosPage />} />
        <Route path="servicios" element={<ServiciosPage />} />
        <Route path="empresa" element={<EmpresaPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
